export const pincodeRegx=/^\d{6}$/;
export const numericRegex = /^\d{10}$/;
export const panRegex=/^[a-zA-Z0-9]{0,9}$/;
export const mobNoRegx = /^[6-9]\d{9}$/;
export const alphabetic = /^[a-zA-Z\s]*$/;
export const alphaNum = /^[a-zA-Z0-9]*$/;
export const alphaNumReg = /[^a-zA-Z0-9]/g;
export const gstRegx= /^[a-zA-Z0-9]{0,50}$/;
export const emailRegx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const webUrlRegx = /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g;
